/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-22 16:29:40
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-16 13:53:56
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SalesChannelMultiLanguageSelect/hooks.ts
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { urlParamsKey } from 'src/constrains/SalesChannelMultiLanguageSelect';
import {
  currentSelectedLanguage,
  fetchSalesChannelAvailableLanguage,
  fetchSalesChannelSpecificLanguageList,
} from 'src/constrains/SalesChannelMultiLanguageSelect/slice';
import { NEW, NULL } from 'src/tools/constant';
import { useAfterDidMountEffect } from 'src/tools/customHooks';
import emit from 'src/tools/event';

const useAfterDidMountLanguageChanged = (func) => {
  //当语言变化后的回掉，也可以不用，直接写
  const language = useSelector(currentSelectedLanguage());
  useAfterDidMountEffect(() => {
    if (func) func();
  }, [language]);
};

const eForceUpdate = (uuid?) => {
  emit.emit(EnumAction.pageLanguageListReload, uuid);
};

enum EnumAction {
  same = 'same',
  changed = 'changed',
  pageLanguageListReload = 'pageLanguageListReload',
}
// {
//   contentUuid,
//   type,
//   salesChannelUuid,
// }

const useQueryLanguageListContentEditor = () => {
  const language = useSelector(currentSelectedLanguage());
  return language;
};

const useGetPageLanguageList = (multiProps) => {
  const p: any = useParams();
  const { noListener } = multiProps;
  const d = useDispatch();
  const getList = (_uuid?) => {
    if (!multiProps) {
      return;
    } else {
      const { type, reduxAccessKeys = [], saleChannelUuid } = multiProps || {};
      const uuidKey = urlParamsKey[type || ''] || '';
      const isNew = p[uuidKey] == NEW || p[uuidKey] == NULL;
      const uuid = _uuid || (isNew ? '' : p[uuidKey] || '');

      if (uuid) {
        d(
          fetchSalesChannelSpecificLanguageList({
            body: {
              type,
              uuid,
              salesChannelUuid: saleChannelUuid,
            },
            salesChannelUuid: saleChannelUuid,
            uuid,
            reduxAccessKeys,
          }),
        );
      } else {
        d(
          fetchSalesChannelAvailableLanguage({
            salesChannelUuid: saleChannelUuid,
          }),
        );
      }
    }
  };
  const uuidGetList = (uuid) => {
    if (!noListener) getList(uuid);
  };

  React.useEffect(() => {
    getList();
    if (!noListener) emit.on(EnumAction.pageLanguageListReload, uuidGetList);
    return () => {
      emit.removeListener(EnumAction.pageLanguageListReload, uuidGetList);
    };
  }, []);
};

export default useGetPageLanguageList;

export {
  useQueryLanguageListContentEditor,
  EnumAction,
  useGetPageLanguageList,
  eForceUpdate,
  useAfterDidMountLanguageChanged,
};
